<template lang="pug">
modal-window.modal-show-movie(:width='600', :height='400', :clickToClose='false', ref='modal')
  .modal-show-movie__inner
    video-control.modal-show-movie__inner__video(:src='movieUrl')
    .modal-show-movie__inner__footer
      button-primary.modal-show-movie__inner__footer__button(@click='hide')
        slot(name='hideText')
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import ModalWindow from '@/components/molecules/student/ModalWindow.vue'
import VideoControl from '@/components/molecules/student/VideoControl.vue'
import ButtonPrimary from '@/components/molecules/student/ButtonPrimary.vue'

/**
 * 動画を見るモーダル
 */
@Component({
  components: {
    ModalWindow,
    VideoControl,
    ButtonPrimary,
  },
})
export default class ModalShowMovie extends Vue {
  // 動画url
  @Prop()
  movieUrl!: string

  @Ref() modal!: ModalWindow

  public show() {
    this.modal.show()
  }

  private hide() {
    this.modal.hide()
  }
}
</script>

<style lang="stylus" scoped>
.modal-show-movie
  &__inner
    padding 10px
    &__video
      width 100%
    &__footer
      display flex
      justify-content center
      padding 5px
      &__button
        width 50%
</style>
